
import { mapGetters, mapActions } from "vuex";
import Notification from '../components/pages/notification.vue';
export default {
	components: {
		headerDefault	: () => import( '../components/header/header-default.vue' ),
		footerDefault	: () => import( '../components/footer/footer-default.vue' ),
		callUsPopUp		: () => import( '../components/pages/call-us-pop-up.vue' ),
		whatsappButtom	: () => import( '../components/pages/whatsapp-buttom.vue' ),
		sidebarAccount	: () => import( '../components/sidebar/account.vue' ),
		sidebarCart		: () => import( '../components/sidebar/cart.vue' ),
		sidebarMenu		: () => import( '../components/sidebar/menu.vue' ),
		sidebarSearch	: () => import( '../components/sidebar/search.vue' )
	},
	data() {
		return {
			template_notification: null,
			show_call_us: false
		}
	},
	head() {
		return {
			title: 'Cata1og.com | Wholesale Portal',
			script: [
			{ defer: true, async: true, src: `https://wchat.freshchat.com/js/widget.js` },
			{ defer: true, async: true, src: "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit" },
			{ defer: true, async: true, src: "https://analytics.ahrefs.com/analytics.js", "data-key":"GX+GKpoFgtjM9Ef2GdOjig" }
			]
		}
	},
	async beforeMount() {
		
		if( !this.$route.query.lang ){
			
			const query = { ...this.$route.query, lang: 'es_MX' };
			this.$router.push({ path: this.$route.path, query });
		}
		await this.changeStoreLang( this.$route.query.lang );
		this.template_notification = Notification;
		this.updateLoginUser( { token_login: this.$cookies.get('token-app'), data_user: this.$cookies.get('user-store'), data_customer: this.$cookies.get('customer-store'), current_route: this.$route.path } );
	},
	async mounted() {
		
		await this.getGeneralSettings().then( (setting_result) => {
			this.addGclid();
		});
		window.addEventListener('scroll', this.handleScroll);
		
		setTimeout(() => {
			this.show_call_us = true;
			
			window.fcWidget.init({
				faqTags	: {
					filterType	: "category",
					tags		: [],
				},
				token	: "03209950-1303-43d7-bfb4-932b0bf43528",
				host	: "https://wchat.freshchat.com",
				siteId	: "Cata1ogUS",
				tags	: ["mx-nuevaorden","orden-mx-seguimiento"],
				config	: {
					disableEvents	: true,
					cssNames		: {
						open	: 'fc_open',
						expanded: 'fc_expanded'
					},
					hideFAQ			: false,
					agent			: {
						hideName: true,
						hidePic	: true,
						hideBio	: true,
					},
					headerProperty	: {
						appName			: 'Cata1ogUS',
						backgroundColor	: '#FFA072',
						foregroundColor	: '#303030',
					},
					content			: {
						actions	: {
							csat_yes		: 'Si',
							csat_no			: 'No',
							push_notify_yes	: 'Si',
							push_notify_no	: 'No',
							tab_faq			: 'FAQ',
							tab_chat		: 'Chat',
							csat_submit		: 'Cargar'
						},
						headers	: {
							chat				: 'Soporte Cata1og MX',
							chat_help			: 'Estamos aquí para ayudarte',
							faq					: 'FAQs',
							faq_help			: "Si tienes alguna pregunta podemos responderte aquí",
							faq_useful			: '¿Fue útil este articulo?',
							faq_thankyou		: 'Gracias por tu comentario',
							faq_message_us		: 'Contáctanos',
							push_notification	: 'No te pierdas ninguna notificacion, ¿Permitir notificaciones?',
							channel_response	: {
								offline	: 'Por ahora no estamos disponibles, contáctanos a la brevedada posible',
								online	: {
									minutes: {
										one	: "Respondemos en 3 minutos ",
										more: "Respodemos en 3 minutos"
									},
								}
							}
						}
					}
				}
			});
		}, 3000);
		
	},
	computed: {
		...mapGetters({
			getterNotification	: 'getterNotification'
		}),
		getShowCallUs(){
			return this.show_call_us;
		},
		getNotification(){
			if( this.getterNotification?.type === "error" && this.getterNotification?.data?.status === 403 ){
				
				this.logoutUser();
				this.$router.push('/account/login');
			}
			else if( this.getterNotification?.type === 'error' ){
				
				let app_version = this.$cookies.get('app-version');
				if( [undefined, null, "null"].includes( app_version ) ){
					
					this.$cookies.set('app-version', this.getterNotification.data.app_version, { path: '/', maxAge: 60 * 60 * 24 * 7 });
				}
				if( this.getterNotification.data?.app_version && ( this.getterNotification.data.app_version != app_version || this.getterNotification?.data.status === 426 ) ){
					
					this.$cookies.set('app-version', this.getterNotification.data.app_version, { path: '/', maxAge: 60 * 60 * 24 * 7 });
					this.$cookies.remove("recently-viewed");
					this.$cookies.remove("gclid");
					this.$cookies.remove("origin_add"); 
					this.$cookies.remove("utmSource"); 
					this.$cookies.remove("utmMedium");
					this.$cookies.remove("utmCampaign");
					this.$cookies.remove("utmTerm");
					window.location.reload();
				}
			}
			if( this.getterNotification?.data && ![403, 426].includes( this.getterNotification?.data.status ) ){
				
				let config_notification = {
					position: "top-right",
					timeout: [ "add-cart-product", "remove-cart-product", "update-cart-product", "save-later-product" ].includes(this.getterNotification.content.type) ? 2000 : 3000,
					closeOnClick: true,
					pauseOnFocusLoss: true,
					pauseOnHover: true,
					draggable: true,
					draggablePercent: 0.6,
					showCloseButtonOnHover: false,
					hideProgressBar: false,
					closeButton: "button",
					icon: ![ "add-cart-product", "remove-cart-product", "update-cart-product", "save-later-product" ].includes(this.getterNotification.content.type),
					rtl: false
				};
				const content = {
					component: this.template_notification,
					props: {
						title	: this.getterNotification.data.title,
						message	: this.getterNotification.data.message,
						content	: this.getterNotification.content
					}
				};
				
				this.$toast[this.getterNotification.type](content, config_notification);
				this.addNotification(null);
				
				return true;
			}
			else{
				
				return false;
			}
		}
	},
	methods: {
		...mapActions({
			changeStoreLang		: 'changeStoreLang',
			getGeneralSettings	: 'getGeneralSettings',
			addNotification		: 'addNotification',
			logoutUser			: 'logoutUser',
			updateLoginUser		: 'updateLoginUser',
		}),
		handleScroll(event){
			
			for (const item_notification of document.getElementsByClassName("Vue-Toastification__container")) {
				
				if( window.innerWidth > 991 && window.top.scrollY >= 134 ){
					
					item_notification.style = "top: 12px !important;";
				}
				else{
					
					item_notification.style = "";
				}
			}
		},
		getParamUrl(p) {
			
			let match = new RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
			return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
		},
		saveLocalParam(local_name, param){
			
			if( param ){
				
				this.$cookies.set(local_name, param, { path: '/', maxAge: 60 * 60 * 24 * 7 });
			}
		},
		getExpiryRecord(value) {
			let expiryPeriod 	= 90 * 24 * 60 * 60 * 1000;
			
			let expiryDate 		= new Date().getTime() + expiryPeriod;
			return {
				value		: value,
				expiryDate	: expiryDate
			};
		},
		addGclid() {
			let gcl_id = {
				value: this.getParamUrl('gclid'),
				fields: ['gclid'],
				object_value: null,
				current_field: null,
				src_valid: !this.getParamUrl('gclsrc') || this.getParamUrl('gclsrc').indexOf('aw') !== -1,
				valid_value: false,
				current_object_value: null
			}
			if (gcl_id.value && gcl_id.src_valid) {
				
				gcl_id.object_value = this.getExpiryRecord(gcl_id.value);
				this.$cookies.set('gclid', JSON.stringify(gcl_id.object_value), { path: '/', maxAge: 60 * 60 * 24 * 7 });
				this.$cookies.set('origin_add', this.$route.fullPath, { path: '/', maxAge: 60 * 60 * 24 * 7 });
			}
			this.saveLocalParam("utmSource"		, this.getParamUrl('utm_source') ); 
			this.saveLocalParam("utmMedium"		, this.getParamUrl('utm_medium') );
			this.saveLocalParam("utmCampaign"	, this.getParamUrl('utm_campaign') );
			this.saveLocalParam("utmTerm"		, this.getParamUrl('utm_term') );
			
			gcl_id.current_object_value = gcl_id.object_value || ( this.$cookies.get('gclid') || null );
			gcl_id.valid_value = gcl_id.current_object_value && new Date().getTime() < gcl_id.current_object_value.expiryDate;
			
			if (gcl_id.valid_value) {
				
				for (const item_field of gcl_id.fields) {
					
					if (document.getElementById(item_field)) {
						
						document.getElementById(item_field).value = gcl_id.current_object_value.value;
					}
				}
			}
		}
	},
	beforeDestroy(){
		
		window.removeEventListener('scroll', this.handleScroll);
	}
}
